import { FileUpload, MuiInputDate, MuiSelect, MuiTextField, RichText } from '@/components';
import { onlyLettersNumbersAndSpace, onlyLettersRegex, onlyNames, worldcountries } from '@/utils';
import i18next from 'i18next';

import * as Yup from 'yup';

const lifeStoryConfig = {
  story_title_image: {
    title: 'select_cover',
    fields: [
      {
        grid: 12,
        name: 'cover_image',
        component: FileUpload,
        label: 'select_cover ',
        required:'true',
        placeholder: 'click_to_upload',
        acceptedFormats: 'image/*',
        isDarkTheme: false,
        validation: Yup.string().required('field_required'),
      },
      {
        grid: 12,
        name: 'title',
        component: MuiTextField,
        label: 'Title ',
        required:'true',
        placeholder: 'title_your_history',
        isDarkTheme: false,
        validation: Yup.string()
          .required('field_required')
          .max(40, i18next.t('max_invalid', { number: 40 })),
      },
      {
        grid: 12,
        name: 'description',
        component: MuiTextField,
        label: 'description',
        placeholder: 'describe_story',
        isDarkTheme: false,
        validation: Yup.string()
          .notRequired()
          .max(255, i18next.t('max_invalid', { number: 255 })),
      },
    ],
  },
};

const classmatesConfig = {
  story_title_image: {
    title: 'select_cover',
    fields: [
      {
        grid: 12,
        name: 'cover_image',
        component: FileUpload,
        label: 'select_cover',
        placeholder: 'click_to_upload',
        required : 'true',
        acceptedFormats: 'image/*',
        isDarkTheme: false,
        validation: Yup.string().required('field_required'),
      },
      {
        grid: 12,
        name: 'title',
        component: MuiTextField,
        label: 'Title ',
        required:'true',
        placeholder: 'title_your_history',
        isDarkTheme: false,
        validation: Yup.string()
          .required('field_required')
          .max(40, i18next.t('max_invalid', { number: 40 })),
      },
      {
        grid: 12,
        name: 'description',
        component: MuiTextField,
        label: 'description',
        placeholder: 'describe_story',
        isDarkTheme: false,
        validation: Yup.string()
          .notRequired()
          .max(255, i18next.t('max_invalid', { number: 255 })),
      },
    ],
  },
 
};

const teammatesConfig = {
  story_title_image: {
    title: 'select_cover',
    fields: [
      {
        grid: 12,
        name: 'cover_image',
        component: FileUpload,
        label: 'select_cover',
        placeholder: 'click_to_upload',
        acceptedFormats: 'image/*',
        isDarkTheme: false,
        validation: Yup.string().required('field_required'),
      },
      {
        grid: 12,
        name: 'title',
        component: MuiTextField,
        label: 'Title',
        required:'true',
        placeholder: 'title_your_history',
        isDarkTheme: false,
        validation: Yup.string()
          .required('field_required')
          .max(40, i18next.t('max_invalid', { number: 40 })),
      },
      {
        grid: 12,
        name: 'description',
        component: MuiTextField,
        label: 'description',
        placeholder: 'describe_story',
        isDarkTheme: false,
        validation: Yup.string()
          .notRequired()
          .max(255, i18next.t('max_invalid', { number: 255 })),
      },
    ],
  },
  
};

const noneOfCategoryConfig = {
  story_title_image: {
    title: 'select_cover',
    fields: [
      {
        grid: 12,
        name: 'cover_image',
        component: FileUpload,
        label: 'select_cover ',
        required:'true',
        placeholder: 'click_to_upload',
        acceptedFormats: 'image/*',
        isDarkTheme: false,
        validation: Yup.string().required('field_required'),
      },
      {
        grid: 12,
        name: 'title',
        component: MuiTextField,
        label: 'Title',
        required:'true',
        placeholder: 'title_your_history',
        isDarkTheme: false,
        validation: Yup.string()
          .required('field_required')
          .max(40, i18next.t('max_invalid', { number: 40 })),
      },
      {
        grid: 12,
        name: 'description',
        component: MuiTextField,
        label: 'description',
        placeholder: 'describe_story',
        isDarkTheme: false,
        validation: Yup.string()
          .notRequired()
          .max(255, i18next.t('max_invalid', { number: 255 })),
      },
    ],
  },
};
const formsByCategory: any = {
  life_story: lifeStoryConfig,
  classmates_story: classmatesConfig,
  teammates_story: teammatesConfig,
  none_of_this_story: noneOfCategoryConfig,
};

export { formsByCategory };
